import { styled } from "@mui/material/styles";
import { Menu, MenuItem } from "@mui/material";

// GlobalFilter.tsx styles
export const FilterButtonWrapper = styled("div")(({ theme }) => ({
  width: "100%",
  display: "flex",
  justifyContent: "flex-end",
  alignItems: "flex-start",
  flex: "1 0 0",
  gap: "8px",

  [theme.breakpoints.down(448)]: {
    justifyContent: "flex-start",
  },
}));

interface FilterButtonProps {
  selected?: boolean;
}
export const FilterButton = styled("button")<FilterButtonProps>(({ selected, theme }) => ({
  unset: "all",
  height: "32px",
  width: "fit-content",
  display: "flex",
  padding: "2px 4px",
  justifyContent: "center",
  alignItems: "center",
  gap: "8px",
  fontSize: "14px",
  cursor: "pointer",
  transition: "background-color 0.3s ease",
  userSelect: "none",

  // conditionals
  borderRadius: "8px",
  background:
    theme.palette.mode === "light"
      ? selected
        ? "#F5F3EF"
        : "#F8F9F9"
      : selected
      ? "#2B2B2B"
      : "#1A1A1A",
  border: "1px solid transparent",
  color:
    theme.palette.mode === "light"
      ? selected
        ? "#1D1A12"
        : "#000"
      : selected
      ? "#F5F5F5"
      : "#E0E0E0",

  "&:hover": {
    background:
      theme.palette.mode === "light"
        ? selected
          ? "#F5F3EF"
          : "#FCFCFB"
        : selected
        ? "#2B2B2B"
        : "#2C2C2C",
    border: `1px solid ${
      theme.palette.mode === "light"
        ? theme.palette.secondary.contrastText
        : theme.palette.primary.contrastText
    }`,
  },
  "&:disabled": {
    cursor: "not-allowed",
    background:
      theme.palette.mode === "light"
        ? "#F0F0F0" // Light mode disabled background
        : "#262626", // Dark mode disabled background
    color:
      theme.palette.mode === "light"
        ? "#A0A0A0" // Light mode disabled text
        : "#666666", // Dark mode disabled text
    border: "1px solid transparent",
    opacity: 0.7,
  },
}));

// DateSelection.tsx styles
export const DateWrapper = styled("div")(() => ({
  display: "flex",
  cursor: "pointer",
}));

export const DateTitleWrapper = styled("div")(() => ({
  fontSize: "12px",
  color: "inherit",
  width: "100%",
  fontWeight: 600,
  display: "inline-flex",
  alignItems: "center",
  gap: "4px",
  fontFamily: "Söhne",
}));

interface TextProps {
  color?: string;
}
export const DateText = styled("span")(({ color }: TextProps) => ({
  display: "inline-flex",
  color: color ?? "inherit",
}));

// DropdownSubmenu.tsx styles
export const CompactMenu = styled(Menu)(() => ({
  "& .MuiPaper-root": {
    minWidth: "100px",
    borderRadius: "6px",
    boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
    border: "1px solid #f0f0f0",
  },
}));

export const CompactMenuItem = styled(MenuItem)(({ selected }) => ({
  fontSize: "12px",
  padding: "4px 8px",
  minHeight: "28px",
  borderRadius: "6px",
  margin: "2px 0px",
  color: selected ? "#002035" : "#4b5563",

  "& .MuiSvgIcon-root": {
    fontSize: "14px",
  },
}));

export const StyledHr = styled("hr")(() => ({
  border: "none",
  height: "1px",
  margin: "4px",
  backgroundColor: "#CCC",
}));

export const RemoveOption = styled("div")(() => ({
  color: "#cc0000",
}));
